import * as Yup from 'yup'
import { schema } from '../../../utils/schemaValidation'
import { getInitialState } from '../../../utils/formikUpdate'
import { getProjectsAll } from '../../../services'
import _ from 'lodash'

export const datasetFormik = async () => {
  const projects = await getProjectsAll()
  const enabledProjects = _.filter(projects, p =>
    p?.habilitado !== undefined ? Boolean(p.habilitado?.data?.[0]) : true
  )

  const projectOptions = {}
  enabledProjects.forEach(p => {
    projectOptions[p.id] = p.nombre
  })

  const defaultProjectId = Object.keys(projectOptions)[0] || ''

  const ITEMS_NEWS_FORMIK = [
    {
      x: 12,
      name: 'titulo',
      initvalue: '',
      label: 'Título',
    },
    {
      x: 12,
      name: 'url',
      initvalue: '',
      label: 'URL',
    },
    {
      x: 12,
      name: 'foto',
      initvalue: '',
      label: 'Imagen (URL opcional)',
    },
    {
      x: 12,
      name: 'contenido',
      initvalue: '',
      label: 'Contenido',
      multiline: true,
      minRows: 4,
    },
    {
      x: 12,
      name: 'idProyecto',
      initvalue: defaultProjectId,
      label: 'Proyecto',
      options: projectOptions,
    },
    {
      x: 12,
      name: 'habilitado',
      initvalue: 1,
      label: 'Habilitado',
      options: { 0: 'Desactivado', 1: 'Activado' },
    },
  ]

  const INITIAL_FORMIK_STATE = getInitialState(ITEMS_NEWS_FORMIK)

  const FORM_VALIDATION = Yup.object().shape({ ...schema.NEWS })

  return {
    INITIAL_FORMIK_STATE,
    ITEMS_NEWS_FORMIK,
    FORM_VALIDATION,
  }
}
